import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import CommunicateStep from "../../../../../../../shared/wizard/steps/communicateStep";
import { EDealRequestCommunicationType } from "../../../../../../../shared/wizard/steps/types";

interface ISelectionByOwnSwapStep_12 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestCommunicationType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnSwapStep_12 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_12) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_11);
    onReset(["communicationType"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_13);
  };

  return (
    <div>
      <CommunicateStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_12;
